module.exports = __webpack_public_path__ + "img/TrialPitExampleLeft.108b8261.jpg";